<div class="container">
  <div>
    <div class="header-container">
      <h1 class="card-body-header">{{ this.cardHeader() }}</h1>
      <div>
        @if (isOnDetailsPage) {
          <div>
            <div class="details-buttons">
              <div class="back-button">
                <dxo-button-v2
                  label="<&nbsp;&nbsp;Back to search employees"
                  variant="secondary"
                  [routerLink]="'/benefits/employees'"
                  [queryParams]="{token}" />
              </div>
              <dxo-button [primary]="true" text="Edit employee" />
            </div>
          </div>
        } @else {
          <div>
            <dxo-button-v2
              label="Add new employee"
              [routerLink]="'/benefits/employees/add'"
              [queryParams]="{token}" />
          </div>
        }
      </div>
    </div>
  </div>
  <div>
    @if (isOnDetailsPage) {
      <div>
        <div>
          <app-employee-detail [employeeId]="this.employeeId"
                               [contractId]="this.contractId"
                               (onReady)="setTitle($event)" />
        </div>
      </div>
    } @else {
      <div>
        <app-employees />
      </div>
    }
  </div>
</div>
